function isTouchEvent(event: Event): event is TouchEvent {
  return 'TouchEvent' in window && 'touches' in event;
}

export default isTouchEvent;
